import {
  agentCursorAnnotationTargets,
  annotationGeometry,
  type ClientRect,
} from "@/lib/agent-annotation";
import { frameScreenRect } from "@/lib/frame-screen-rect";
import { annotationInkOverflow } from "@/lib/annotation-sketch";
import type { AgentCursor } from "@/stores/canvas-store";
import { getWindowDisplayId } from "@/desktop/use-window-role";

export function cursorBubbleExclusions(
  cursor: AgentCursor,
  origin: { x: number; y: number },
  viewport: { width: number; height: number },
): ClientRect[] {
  const exclusions: ClientRect[] = [];
  const displayId = getWindowDisplayId();
  for (const target of agentCursorAnnotationTargets(cursor)) {
    if (target.dismissed) continue;
    if (displayId !== null && target.displayId !== displayId) continue;
    const geometry = annotationGeometry(
      target,
      origin,
      viewport,
      annotationInkOverflow(target),
    );
    if (geometry) exclusions.push(geometry);
  }
  const targetGroups = [
    cursor.annotationExclusionTargets,
    cursor.frameExclusionTargets,
  ];
  for (const target of targetGroups.flatMap((group) => group ?? [])) {
    if (displayId !== null && target.displayId !== displayId) continue;
    exclusions.push({
      left: target.globalX - origin.x,
      top: target.globalY - origin.y,
      right: target.globalX - origin.x + target.width,
      bottom: target.globalY - origin.y + target.height,
    });
  }
  const frameIds = new Set(cursor.exclusionFrameIds ?? []);
  if (cursor.targetFrameId) frameIds.add(cursor.targetFrameId);
  for (const frameId of frameIds) {
    const rect = frameScreenRect(frameId);
    if (!rect) continue;
    exclusions.push({
      left: rect.left,
      top: rect.top,
      right: rect.left + rect.width,
      bottom: rect.top + rect.height,
    });
  }
  return exclusions;
}
